import moment from 'moment';
import i18n from 'src/i18n';

const mixinFilter = {
  data() {
    return {
      valueCollapse: null,
      dataFilter: {
        datef: moment().format('YYYY-MM-DD'),
        datei: moment().subtract(1, 'year').format('YYYY-MM-DD'),
        farm: [],
      },
    };
  },

  computed: {
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? i18n.t('uti.mixinFilter.hideFilters')
          : i18n.t('uti.mixinFilter.showFilters');
      }

      return i18n.t('uti.mixinFilter.hideFilters');
    },
  },

  methods: {
    handleCollapse(val) {
      this.valueCollapse = val;
    },
  },
};

export default mixinFilter;
